import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
    stock: {
        'systemName': 'Stylbiella Service',
        //'systemName': 'Vitality Information Platform',
        'mainPage': 'Main Page',
        'saleCode': 'Fabric',
        'tabtitle':'By Fabric',
        'tabtitle_pic':'By Lookbook',
        'tabtitle_sample':'By Bunch',
        'tabtitle_express_delivery': 'Shipment Tracking',
        'saleCodeTip': 'Fabric Code...',
        'pictureCoding':'Pls select Lookbook',
        'sampleCoding':'Pls select Bunch..',
        'choosestatus':'Please select state',
        'deliveryCodeTip': 'Query by SO No. or DO No.',
        'statetypeone':'all',
        'statetypetwo':'Supplying',
        'exportdata':'export',
        'search': 'Search',
        'maxLengthofABlock': 'Stock',
        'brand':'Brand',
        'clearance':'Clearance',
        'clearanceContent':'clearance',
        'photo':'photo',
        'latestReplenishmentDate': 'Restock',
        'operation': 'Operation',
        'details': 'Details',
        'basicInformation': 'Basic Information',
        'remarks': 'Remarks',
        'chinese': '中文',
        'english': 'English',
        'endOfSale': 'Stop selling',
        'yarn': 'Yarn',
        'component': 'Component',
        'weight': 'Weight/g',
        'supplying': 'Supplying',
        '40over': '40+',
        '50over': '50+',
        '60over': '60+',
        '70over': '70+',
        'chooselanguage': 'Language',
        'doNo': 'DO No.',
        'expressNo': 'Shipment Tracking No.',
        'refSoNo': 'SO No.',
        'remarks': 'Remarks',
        'deliveryRemarks': 'Delivering',
        'deliverySearchTip1': 'Delivering, please wait!',
        'deliverySearchTip2': 'We currently do not support tracking the waybill for this shipping method!',

        'qrScan': '',
        'qrScan2': 'QR SCAN',
        'barScan': '',
        'barScan2': 'BAR SCAN',
        'productNoTip': 'Product No. Here',

        'ocr': 'Enter the product number to check inventory.',
        'ocrText': '',

        'brand': 'Brand',
        'inventory': 'Inventory',
        'code': 'ProductNo.',
        'replenishment': 'Replenishment',
        'yarn': 'S VALUE',
        'component': 'Composition',
        'weight': 'Linear Weight',
    },
    ...enLocale

}
export default en;
